<form
  *ngIf="init && form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <div class="grid" formGroupName="properties">
    <app-form-field-wrapper [label]="'Schlüssel'" [name]="'key'" [colSize]="4">
      <input
        pInputText
        id="key"
        type="text"
        formControlName="key"
        class="p-input" />
    </app-form-field-wrapper>
    <app-form-field-wrapper [label]="'Name'" [name]="'name'" [colSize]="8">
      <input
        pInputText
        id="name"
        type="text"
        formControlName="name"
        class="p-input" />
    </app-form-field-wrapper>

    <app-form-field-wrapper [label]="'Gruppe'" [name]="'group'" [colSize]="12">
      <input
        pInputText
        id="group"
        type="text"
        formControlName="group"
        class="p-input" />
    </app-form-field-wrapper>

    @for (prop of editorProperties; track $index) {
      <app-form-field-wrapper
        [colSize]="6"
        [label]="prop.label"
        [name]="prop.key"
        [floatingLabel]="false"
        [hideLabel]="false">
        <p-editor
          [modules]="{ nbspFix: true }"
          [formControlName]="prop.key"
          [style]="{ height: '100px' }">
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button type="button" class="ql-bold" aria-label="Bold"></button>
              <button
                type="button"
                class="ql-italic"
                aria-label="Italic"></button>
              <button
                type="button"
                class="mr-3 ql-underline"
                aria-label="Underline"></button>
              <button type="button" class="ql-link" aria-label="Link"></button>
            </span>
          </ng-template>
        </p-editor>
      </app-form-field-wrapper>
    }
  </div>
  <p-divider></p-divider>
  <div class="flex gap-3">
    <p-button
      severity="secondary"
      styleClass="w-auto"
      icon="fas fa-times"
      (click)="closeMetaForm.emit()"
      [rounded]="true"
      label="abbrechen">
    </p-button>
    <p-button
      icon="fas fa-save"
      styleClass="w-auto"
      [disabled]="form.invalid"
      label="übertragen"
      [rounded]="true"
      type="submit"></p-button>
  </div>
</form>
